import React from 'react';
import styled from 'styled-components';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { textSize } from '@styles';
import Router from "next/router";

export const Tags = ({ tagsStyle, tagsRoom }) => {
  function onLinkTag(event) {
    event.preventDefault();

    Router.push(this.link);
  }

  return (
      <Container>
        <Wrapper>
          <TagList>

            {tagsStyle.map((tag) => (
              <TagLink key={tag.id} isActive={tag.active} isSecondMode={false}>
                <Link isActive={tag.active} onClick={onLinkTag.bind(tag)}>
                  <a href={tag.href} onClick={(event) => {event.preventDefault();}}>{tag.name.toLowerCase()}</a>
                  {tag.active && <RemoveTag/>}
                </Link>
              </TagLink>
            ))}

          </TagList>

          <TagList>

            {tagsRoom.map((tag, index) => (
              <TagLink key={index} isActive={tag.active} isSecondMode={true}>
                <Link isActive={tag.active} onClick={onLinkTag.bind(tag)}>
                  <a href={tag.href} onClick={(event) => {event.preventDefault();}}>{tag.name.toLowerCase()}</a>
                  {tag.active && <RemoveTag/>}
                </Link>
              </TagLink>
            ))}

          </TagList>
        </Wrapper>
      </Container>
  );
};

const Container = styled.nav`
  ${Grid.post(-2.2)};
  ${Grid.push(-2.2)};
`;

const Wrapper = styled.div`
  overflow: auto;
  white-space: nowrap;
`;

const TagList = styled.ul`
  ${Mixins.resetList()};
  display: flex;
  margin-bottom: 10px;
`;

const TagLink = styled.li`
  ${Mixins.transition('color')};
  ${textSize('p')};
  margin: 0 2px;
  display: block;
  color: ${({ isActive }) => (isActive ? Colors.white : Colors.night)};

  &:first-child {
    ${Grid.prefix(1, 20)};
    margin-left: auto;
    
  }
  
  &:last-child {
    ${Grid.suffix(1, 20)};
    margin-right: auto;
  }

  a {
    ${Mixins.resetLink()};
    color: inherit;
  }
`;

const Link = styled.span`
  ${Mixins.transition('background')};
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 20px;
  border: ${({isActive}) => (isActive ? `1px solid transparent` : `1px solid ${Colors.coal}`)};
  background: ${({ isActive, isSecondMode }) => (isActive ? isSecondMode ? Colors.colar : Colors.night : Colors.white)};
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  
  &:hover {
    color: ${Colors.white};
    background: ${({ isSecondMode }) => (isSecondMode ?  Colors.colar : Colors.night)};
    border: 1px solid transparent;
  }
`;

const RemoveTag = styled.span`
  pointer-events: none;
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${Colors.white};
  margin-left: 5px;
  position: relative;
  margin-top: 2px;
  
  &:before,
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 1px;
    background-color: ${Colors.night};
    transform: translate(-50%, -50%) rotate(45deg);
  }
  
  &:before {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;
